import { EventEmitter, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, filter, map, Observable, of, switchMap, take, tap, throwError } from 'rxjs';
import { Pagination } from "sjx/common/model/domain-entity.model";
import { environment } from "environments/environment";
import { UiViewLytConf } from 'sjx/ui-view-lyt-conf/ui-view-lyt-conf.model';

@Injectable({
  providedIn: 'root'
})

export abstract class DomainEntityService {

  // Private
  protected _pagination: BehaviorSubject<Pagination> = new BehaviorSubject(new Pagination());
  protected _domainEntity: BehaviorSubject<any> = new BehaviorSubject({});
  protected _domainEntities: BehaviorSubject<any[]> = new BehaviorSubject([]);
  protected _layoutConfigs: BehaviorSubject<UiViewLytConf[]> = new BehaviorSubject([]);

  protected pageSize : number = 10;
  protected nestedAttr : string = "";
  protected searchFilter : string = "";
  protected entityUrl : string = "";
  protected sortFilter : string = "";
  protected cParam : string = "";
  timerReset: EventEmitter<void> = new EventEmitter<void>();


  /**
   * Constructor
   */
  constructor(protected _httpClient: HttpClient) { 
  }

  resetPagination(){
    this._pagination.getValue().pageNumber = 0;
  }
  /**
  * Getter & Setter for pagination
  */
  set pagination(value: Pagination) {
    // Store the value
    this._pagination.next(value);
  }

  get pagination$(): Observable<Pagination>
  {
    return this._pagination.asObservable();
  }

  /**
  * Getter for DomainEntity
  */
  get domainEntity$(): Observable<any>
  {
    return this._domainEntity.asObservable();
  }

  /**
  * Getter for DomainEntitys
  */
  get domainEntities$(): Observable<any[]>
  {
    return this._domainEntities.asObservable();
  }

  /**
  * Getter for Layout Configs
  */
   get layoutConfigs$(): Observable<UiViewLytConf[]>
   {
     return this._layoutConfigs.asObservable();
   }

   public setPageSize(pSize:number): void
   {
     this.pageSize = pSize;
   }

   public setNestedAttr(nAttr:string): void {
    this.nestedAttr = nAttr;
  }

  public setSearchFilter(search:string): void {
    this.searchFilter = search;
  }

  public getSearchFilter():string{
    return this.searchFilter;
  }

  public setEntityUrl(url:string): void {
    this.entityUrl = url;
  }

  public getEntityUrl():string{
    return this.entityUrl;
  }
  
  public setSortFilter(fltr : string){
    this.sortFilter = fltr;
  }

  public setCParam(val:string): void {
    this.cParam = val;
  }

  public getCParam():string{
    return this.cParam;
  }



   abstract getEntityName():string;


   abstract getNestedAttr():string;   

  // -----------------------------------------------------------------------------------------------------
  // @ Public methods || API Integration for CRUD Operations
  // -----------------------------------------------------------------------------------------------------

  /**
   * Get DomainEntitys
   */
  getDomainEntities(): Observable<any[]>
  {
    // if (this.getEntityUrl() == "candidates") {
    //   return this._httpClient.get<any>(environment.seApiURL + '/'+ this.getEntityUrl() +'/', {
    //     params: {
    //       search : this.getSearchFilter(),
    //       page: this._pagination.getValue().pageNumber || 0,
    //       size: this._pagination.getValue().size || this.pageSize,
    //       nestedAttr : this.getNestedAttr(),
    //       cParam: this.cParam
    //     }
    //   }).pipe(
    //     tap((domainEntities) => {
    //       this.resetTimer();
    //       //this._domainEntities.next(domainEntities.hits);
    //       this._domainEntities.next(domainEntities.content);

    //       let pNum = this._pagination.getValue().pageNumber || 0;
    //       let pSize = this._pagination.getValue().size || this.pageSize;

    //       //this._setCurrPagination(domainEntities);
    //       let currPagination: Pagination = new Pagination();    
    //       currPagination.totalElements = domainEntities.total;
    //       currPagination.totalPages = (domainEntities.total/pSize) + (domainEntities.total/pSize == 0 ? 0 : 1);
    //       currPagination.size = pSize;
    //       currPagination.numberOfElements = pSize;
    //       currPagination.pageNumber = pNum;     // It's count starts from 0
    //       currPagination.lastPage = pNum == (currPagination.totalPages -1) ? true : false;
    //       currPagination.firstPage = pNum == 0 ? true : false;
    //       currPagination.empty = false;
    //       this._pagination.next(currPagination);
    //     })
    //   );
    // } else {
      return this._httpClient.get<any>(environment.seApiURL + '/'+ this.getEntityUrl() +'/', {
        params: {
          search : this.getSearchFilter(),
          page: this._pagination.getValue().pageNumber || 0,
          size: this._pagination.getValue().size || this.pageSize,
          nestedAttr : this.getNestedAttr(),
          sort : this.sortFilter,
          cParam: this.cParam
        }
      }).pipe(
        tap((domainEntities) => {
          this.resetTimer();
          this._domainEntities.next(domainEntities.content);
          this._setCurrPagination(domainEntities);
        })
      );
    // }
  }

  /**
   * 
   * @returns 
   */
  getLayoutConfigurations(): Observable<UiViewLytConf[]>
  {
    return this._httpClient.get<any>(environment.seApiURL + '/ui-view-layout-configs', {
      params: {
        search: "viewNm=="+this.getEntityName()[0].toUpperCase() + this.getEntityName().substr(1),
        nestedAttr : 'uiAttrLytConfs,uiGrpLytConfs'
      }
    }).pipe(
      tap((configs) => {
          this._layoutConfigs.next(configs.content);
        })
      );

  }

  /**
   * Get DomainEntity by id
   */
  getDomainEntityById(domainEntityId : string): Observable<any> {  
    if (domainEntityId === "new") {
      this._domainEntity.next({});
      return this._domainEntity;
    }
    return this._httpClient.get<any>(environment.seApiURL + '/'+ this.getEntityUrl() +'/' +  domainEntityId , {
      params: {
        nestedAttr : this.getNestedAttr()
      }
    }).pipe(
      tap((domainEntity) => {
        this.resetTimer();
        if (!domainEntity) {
          return throwError('Could not find '+' with id of ' + domainEntityId);
        }
        this._domainEntity.next(domainEntity);
      })
    );
  }

  /**
  * Create DomainEntity
  */
  createDomainEntity(domainEntity: any): Observable<any> {
    this.resetTimer();
    return this._httpClient.post<any>(environment.seApiURL + '/'+ this.getEntityUrl() +'',domainEntity);

    // return this.domainEntities$.pipe(
    //   take(1),
    //   switchMap(domainEntities => this._httpClient.post<any>(environment.seApiURL + '/'+ this.getEntityUrl() +'',
    //     domainEntity
    //   ).pipe(
    //     map((newDomainEntity) => {

    //       // Update the DomainEntitys with the new domainEntity
    //       this._domainEntities.next([newDomainEntity, ...domainEntities]);

    //       // Return the new domainEntity
    //       return newDomainEntity;
    //     })
    //   ))
    // );
  }

  /**
  * Update DomainEntity
  *
  * @param id
  * @param domainEntity
  */
  updateDomainEntity(domainEntityId : string, domainEntity: any): Observable<any> {
    this.resetTimer();
    return this._httpClient.put<any>(environment.seApiURL + '/'+ this.getEntityUrl() +'/' + domainEntityId, domainEntity);
    // return this.domainEntities$.pipe(
    //   take(1),
    //   switchMap(domainEntities => this._httpClient.put<any>(environment.seApiURL + '/'+ this.getEntityUrl() +'/' + domainEntityId, domainEntity)
    //     .pipe(
    //           map((updatedDomainEntity) => {
    //             // Find the index of the updated DomainEntity
    //             const index = domainEntities.findIndex(item => item.domainEntityId === domainEntityId );

    //             // Update the DomainEntity
    //             domainEntities[index] = updatedDomainEntity;

    //             // Update the DomainEntit
    //             this._domainEntities.next(domainEntities);

    //             // Return the updated domainEntity
    //             return updatedDomainEntity;
    //           }),
    //           switchMap(updatedDomainEntity => this.domainEntity$.pipe(
    //             take(1),
    //             filter(item => item && item.domainEntityId === domainEntityId),
    //             tap(() => {

    //               // Update the product if it's selected
    //               this._domainEntity.next(updatedDomainEntity);

    //               // Return the updated product
    //               return updatedDomainEntity;
    //             })
    //           ))
    //         ))
    // );
  }

  /**
  * Delete the DomainEntity
  *
  * @param id
  */
  // deleteDomainEntity(id: string): Observable<boolean> {
    deleteDomainEntity(id: string): Observable<any> {
      this.resetTimer();
    return this._httpClient.delete(environment.seApiURL + '/'+ this.getEntityUrl() +'/' + id);

    // return this.domainEntities$.pipe(
    //   take(1),
    //   switchMap(domainEntities => this._httpClient.delete(environment.seApiURL + '/'+ this.getEntityUrl() +'/' + id).pipe(
    //     map((isDeleted: boolean) => {

    //       // Find the index of the deleted product
    //       const index = domainEntities.findIndex(item => item.domainEntityId === id);

    //       // Delete the product
    //       domainEntities.splice(index, 1);

    //       // Update the products
    //       this._domainEntities.next(domainEntities);

    //       // Return the deleted status
    //       return isDeleted;
    //     })
    //   ))
    // );
  }

  private _setCurrPagination(paginationDetails: any) {
    let currPagination: Pagination = new Pagination();    
    currPagination.totalElements = paginationDetails.totalElements;
    currPagination.totalPages = paginationDetails.totalPages;
    currPagination.size = paginationDetails.size;
    currPagination.numberOfElements = paginationDetails.numberOfElements;
    currPagination.pageNumber = paginationDetails.number;     // It's count starts from 0
    currPagination.lastPage = paginationDetails.last;
    currPagination.firstPage = paginationDetails.first;
    currPagination.empty = paginationDetails.empty;
    this._pagination.next(currPagination);
  }

  // Auto logout reset timer function

  resetTimer() {
    this.timerReset.emit();
  }

}
